import services from 'utils/mockAdapter';
// user list
const Dealers = [
    {
        id: '10011',
        name: 'Dealer 1 ',
        address: '97 S Timber Rd Hollad PA 18966',
        dealername: 'David Sterling',
        dealerphone: '+1-917-440-3563',
        servicephone: '+1-917-440-3563',
        dealermail: 'Main@delaer1.com',
        dealermailalert: '1'
    },
    {
        id: '10011',
        name: 'Dealer 2 ',
        address: '97 S Timber Rd Hollad PA 18966',
        dealername: 'David Sterling',
        dealerphone: '+1-917-440-3563',
        servicephone: '+1-917-440-3563',
        dealermail: 'Main@delaer1.com',
        dealermailalert: '0'
    },
    {
        id: '10011',
        name: 'Dealer 3',
        address: '97 S Timber Rd Hollad PA 18966',
        dealername: 'David Sterling',
        dealerphone: '+1-917-440-3563',
        servicephone: '+1-917-440-3563',
        dealermail: 'Main@delaer1.com',
        dealermailalert: '0'
    },
    {
        id: '10011',
        name: 'Dealer 4 ',
        address: '97 S Timber Rd Hollad PA 18966',
        dealername: 'David Sterling',
        dealerphone: '+1-917-440-3563',
        servicephone: '+1-917-440-3563',
        dealermail: 'Main@delaer1.com',
        dealermailalert: '1'
    },
    {
        id: '10011',
        name: 'Dealer 5 ',
        address: '97 S Timber Rd Hollad PA 18966',
        dealername: 'David Sterling',
        dealerphone: '+1-917-440-3563',
        servicephone: '+1-917-440-3563',
        dealermail: 'Main@delaer1.com',
        dealermailalert: '1'
    },
    {
        id: '10011',
        name: 'Dealer 6 ',
        address: '97 S Timber Rd Hollad PA 18966',
        dealername: 'David Sterling',
        dealerphone: '+1-917-440-3563',
        servicephone: '+1-917-440-3563',
        dealermail: 'Main@delaer1.com',
        dealermailalert: '0'
    },
    {
        id: '10011',
        name: 'Dealer 7 ',
        address: '97 S Timber Rd Hollad PA 18966',
        dealername: 'David Sterling',
        dealerphone: '+1-917-440-3563',
        servicephone: '+1-917-440-3563',
        dealermail: 'Main@delaer1.com',
        dealermailalert: '0'
    },
    {
        id: '10011',
        name: 'Dealer 8 ',
        address: '97 S Timber Rd Hollad PA 18966',
        dealername: 'David Sterling',
        dealerphone: '+1-917-440-3563',
        servicephone: '+1-917-440-3563',
        dealermail: 'Main@delaer1.com',
        dealermailalert: '1'
    }
];
// ==============================|| MOCK SERVICES ||============================== //
services.onGet('/api/manufacturers/dealers/list').reply(200, { Dealers });
